module.exports = __webpack_public_path__ + "site/img/130.5556ef06.jpg";